import {GenericPaginatorState} from './paginator.model';
import {GenericSortState} from './sort.model';
import {Signal} from "@angular/core";
import {BehaviorSubject} from "rxjs";

/**
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export interface IGenericTableService {
  get items(): Signal<any[] | undefined | null>
  get paginator(): GenericPaginatorState;
  get sorting(): GenericSortState;
  get isLoading$(): BehaviorSubject<boolean>;

  fetchApollo(): void;
  /**
   * async method
   */
  patchStateApollo(patch: Partial<GenericTableState>): Promise<void>
  /**
   * async method
   */
  refreshApolloQuery(): Promise<void>
}

/**
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export interface GenericTableState {
  filter: {};
  searchableFields: GenericSearchableFieldsType
  paginator: GenericPaginatorState;
  sorting: GenericSortState;
  searchTerm: string;
  // grouping: GenericGroupingState;
}

/**
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export type GenericSearchableFieldsType = (string | {[key: string]: string[]} )[];
